import { ChangeEventHandler, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { TextField } from "components/text-field";
import { PsychologistProfile } from "core/types";

type Props = {
  psychologist: Pick<PsychologistProfile, "hsa">;
  onChange: (x: string) => ChangeEventHandler<HTMLInputElement>;
};

const EditableBigCode = ({
  psychologist,
  onChange,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation();

  return (
    <StyledTextFieldWrapper>
      <TextField
        label={`${t("BIG_CODE")}`}
        value={psychologist.hsa ?? ""}
        sensitiveField={true}
        onChange={onChange("hsa")}
      />
    </StyledTextFieldWrapper>
  );
};

const StyledTextFieldWrapper = styled.div`
  .MuiFormControl-marginNormal {
    margin-top: 0;
  }
`;

export default EditableBigCode;
